import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Layout from "../../../Components/layout";
import logo from "../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import KsaService from "../../../Utilies/Utilies/KsaService";
import KsaLebaraTerms from "./KsaLebaraTerms";
import "./KsaLebaraVerify.css";
import { notify1 } from "../../../Components/ToastComponent";

const RESEND_COOLDOWN_SECONDS = 60;

const parseVerifyData = () => {
  try {
    const data = localStorage.getItem("verifyData");
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

const getSubscriptionContractIdFromData = (data) => {
  if (!data) return null;

  const contract = data.contract || {};

  return (
    data.subscriptionContractId ??
    data.subscription_contract_id ??
    contract.subscriptionContractId ??
    contract.subscriptionContractID ??
    contract.SubscriptionContractId ??
    contract.id ??
    null
  );
};

const KsaLebaraVerify = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [verifyData, setVerifyData] = useState(() => parseVerifyData());
  const [trafficsource, setTrafficsource] = useState("");
  const [parameter, setParameter] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    getVerifyData();
    getMarketingParams();
  }, []);

  useEffect(() => {
    if (countdown <= 0) return undefined;

    const timer = setTimeout(() => {
      setCountdown((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  const getVerifyData = () => {
    const data = parseVerifyData();
    if (data) {
      setVerifyData(data);
    }
  };

  const getMarketingParams = () => {
    const ts = localStorage.getItem("trafficsource");
    const param = localStorage.getItem("parameter");
    if (ts) setTrafficsource(ts);
    if (param) setParameter(param);
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setOtp(value);
   
  };

  const verify = async () => {
    if (!otp || !verifyData) {
      setErrMsg(t("enter_otp_placeholder"));
      return;
    }

    setIsLoading(true);
    setErrMsg("");

    try {
      const lang = localStorage.getItem("i18nextLng") || "en";
      const payload = {
        ...verifyData,
        pinCode: otp,
        company: trafficsource || null,
        key: parameter || null,
        lang: lang,
      };

      const res = await KsaService.verify(payload);

      if (res.success) {
        navigate("/success");
      } else {
        setErrMsg(res.message || t("Something went wrong! Please make sure you have the correct verification code inserted or try again later."));
      }
    } catch (err) {
      if(err.response?.data?.message == '302:InvalidPinCodeOrPassword'){
        setErrMsg(t("Invalid PIN code or password"));
      } 
      else {
        setErrMsg(
          err?.response?.data?.message ||
            t("Something went wrong! Please make sure you have the correct verification code inserted or try again later.")
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    verify();
  };

  const formatCountdown = () => {
    const minutes = Math.floor(countdown / 60);
    const seconds = countdown % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`;
  };

  const resendPinCode = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();

    if (countdown > 0 || isResending) return;

    const latestVerifyData = parseVerifyData() || verifyData;
    const subscriptionContractId =
      getSubscriptionContractIdFromData(latestVerifyData);

    if (
      subscriptionContractId === null ||
      subscriptionContractId === undefined ||
      subscriptionContractId === ""
    ) {
      setErrMsg(t("Something went wrong"));
      notify1(t("Something went wrong"));
      return;
    }

    setIsResending(true);
    setErrMsg("");

    try {
      const res = await KsaService.resendOtp({ subscriptionContractId });

      if (res?.success === true || res?.success === "true" || res?.status === true) {
        setOtp("");
        setCountdown(RESEND_COOLDOWN_SECONDS);
        setErrMsg("");
      } else {
        notify1(res?.message || t("Something went wrong"));
      }
    } catch (err) {
      notify1(err?.response?.data?.message || t("Something went wrong"));
    } finally {
      setIsResending(false);
    }
  };

  return (
    <Layout>
      <img className="servImg mb-4" src={logo} alt="" />

      <div className="ksa-verify-content">
        <div className="signup-form col-md-6 m-auto">
          <form onSubmit={handleSubmit} dir="ltr">
            <h3 className="text-center ">
              {t("iraq-zain.Enter The Your PIN")}
            </h3>

            <div className="mb-3 form-group col-md-12 col-12">
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="6"
                className={`form-control  shadow-none ${
                  otp ? "is-valid" : ""
                } ${errMsg ? "is-invalid" : ""}`}
                placeholder={t("Enter OTP That You Recieve")}
                value={otp}
                onChange={handleOtpChange}
              />
            </div>

            {errMsg && (
              <span className="text-danger bg-danger-subtle d-block rounded p-1 mb-2 text-center">
                {errMsg}
              </span>
            )}

            {countdown > 0 && (
              <p className="text-center text-white mb-3 resend-timer">
                {t("Time Remaining :")}{" "}
                <span>{formatCountdown()}</span>
              </p>
            )}

            <div className="mb-3 form-group text-center">
              <button
                type="button"
                className="resend-otp-btn"
                onClick={resendPinCode}
                disabled={countdown > 0 || isResending}
              >
                {isResending ? t("Processing") : t("Resend OTP")}
              </button>
            </div>

            <div className="mb-3 form-group">
              <button
                id="sub_btn"
                type="submit"
                disabled={!otp || isLoading}
                className="shadow-none btn submit-btn col-12 m-auto d-block"
              >
                {isLoading ? t("verifying") : t("Confirm")}
              </button>
            </div>
          </form>
        </div>

        <div className="terms ms-md-4 mt-3">
          <KsaLebaraTerms />
        </div>
      </div>
    </Layout>
  );
};

export default KsaLebaraVerify;
